function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6a920",
  d: "M13.25 0v15.83h3.99V3.97h35.92v11.86h3.99V0zM53.16 57.09v11.86H17.24V57.09h-3.99v15.83h43.9V57.09z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.63 32.26l8-10.69v-1.46H23.8v4.84h12.52l-7.7 10.24v1.46h3.54c2.47 0 4.38.52 5.73 1.56a5.22 5.22 0 012.03 4.39c0 1.88-.65 3.4-1.95 4.56a7.15 7.15 0 01-4.94 1.74 8.04 8.04 0 01-5.25-1.94l-2.47 4.31c.66.65 0 0 .8.53 2 1.33 4.36 2 7.07 2 3.38 0 6.26-1.05 8.64-3.13a10.28 10.28 0 003.57-8.12c0-2.83-.86-5.14-2.58-6.93s-3.79-2.92-6.19-3.36M68.28 25.14a7.04 7.04 0 012.35 5.5 7.1 7.1 0 01-2.35 5.52c-1.56 1.41-3.6 2.12-6.13 2.12h-5.12v11.6h-4.01V23.03h9.13c2.52 0 4.57.7 6.13 2.11m-2.93 8.49a3.9 3.9 0 001.15-2.95c0-1.23-.38-2.22-1.15-2.98-.77-.75-1.87-1.13-3.28-1.13h-5.04v8.17h5.04c1.41 0 2.5-.37 3.28-1.11M13.48 25.05v9.5H4.06V23.03H0v26.85h4.06V38.14h9.42v11.74h4.07V23.03h-4.07z"
});

var SvgLogoH3P = function SvgLogoH3P(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71 73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoH3P, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-h3p.bee57ffd.svg";
export { ForwardRef as ReactComponent };